import React, { useState, useCallback, useEffect, useRef } from "react";
import _ from "lodash";
import {
  _getSelectedOption,
  _getBaseUrl,
  _isFirstRender,
  _getCSRFTokenValue,
  _getTileShape,
} from "../utils/helper";
import api from "../utils/api";
import { Loader, Pagination } from "../atoms";
import StateView from "../utils/StateView";
import { Modal, PostSavedMessage } from "../molecules";

const INITIAL_VALUES = {
  type: [],
  postStatus: [],
  nodeStatus: [true, false],
  orderBy: "changed",
  uid: 10,
  userRoles: [],
  page: 1,
};

const InspiratiepuntenDashboard = (props) => {
  const [values, setValues] = useState(INITIAL_VALUES);
  const [options, setOptions] = useState({});
  const [posts, setPosts] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);
  const [isFirstLoadPosts, setIsFirstLoadPosts] = useState(true);
  const [deletePostNid, setDeletePostNid] = useState(null);
  const [isDeletingPost, setIsDeletingPost] = useState(false);

  const [showPostSavedMessage, setShowPostSavedMessage] = useState(null);

  useEffect(() => {
    fetchOptions();

    setValues({
      ...values,
      uid: props.data.uid,
      userRoles: JSON.parse(props.data.userroles),
    });

    const urlParams = new URLSearchParams(window.location.search);    
    if ([...urlParams].length > 0) {
      if (urlParams.has('t')) {
        setTimeout(() => {
          setShowPostSavedMessage({ title: decodeURIComponent(urlParams.get('t')) });
        }, 1500);
      }
    }
  }, []);

  useEffect(() => {
    fetchPosts(values);
  }, [values]);

  const fetchOptions = async () => {
    api
      .get("/inspiratiepunten_filteroptions")
      .then((res) => {
        setIsLoadingPosts(false);
        setOptions(res.data.options);
      })
      .catch(() => {
        // setIsLoadingPosts(false);
      });
  };

  const fetchPosts = async (values) => {
    setIsLoadingPosts(true);

    const csrfToken = await _getCSRFTokenValue();
    const data = values;

    api
      .post("/inspiratiepunten_searchandfilter", data, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        setPosts(res.data.posts);
        setTotalPages(res.data.totalPages);
        setIsFirstLoadPosts(false);
        setIsLoadingPosts(false);
      })
      .catch(() => {
        setIsLoadingPosts(false);
        setIsFirstLoadPosts(false);
      });
  };

  const deletePost = async () => {
    setIsDeletingPost(true);

    const csrfToken = await _getCSRFTokenValue();
    const data = {
      nid: deletePostNid,
    };

    api
      .post("/inspiratiepunten_node_delete", data, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        setIsDeletingPost(false);
        setDeletePostNid(null);
        setPosts(posts.filter(post => post.nid !== deletePostNid));
      })
      .catch(() => {
        setIsDeletingPost(false);
      });
  }

  const getPostTitle = (nid) => {
    const post = posts.find(post => post.nid === nid);

    if (post) {
      return post.title;
    }

    return "";
  }

  const downloadCSV = (values) => {
    let restUrl = _getBaseUrl() + 'praktijkervaring/csv-export/projects';

    let params = {};

    // if (values.keywords.length > 0) {
    //   params['keywords'] = [values.keywords[0]];
    // }

    if (values.postStatus.length > 0) {
      params['postStatus'] = values.postStatus;
    }

    // if (values.transitieagenda.length > 0) {
    //   params['transitieagenda'] = [values.transitieagenda[0]];
    // }

    if (values.type.length > 0) {
      params['type'] = [values.type[0]];
    }

    if (values.uid !== null) {
      params['uid'] = values.uid;
    }

    console.log('Params for CSV export:', params);

    const paramsJson = JSON.stringify(params);

    restUrl += '?data=' + encodeURIComponent(paramsJson);

    console.log('CSV export URL:', restUrl);

    window.open(restUrl, '_blank');
  }

  return (
    <React.Fragment>
      <div className="flex gap-4 justify-start mb-4">
        <div className="w-64">
          <label htmlFor="projectType" className="block pr-4 mb-1">
            Type
          </label>
          <div className="w-full relative col-span-1 col-start-2 select-arrow">
            <select
              id="projectType"
              name="type"
              className="w-full border p-2 appearance-none select-arrow"
              onChange={(e) =>
                e.target.value === ""
                  ? setValues({ ...values, type: [], page: 1 })
                  : setValues({ ...values, type: [e.target.value], page: 1 })
              }
            >
              <option value="">Alles</option>
              {options.project_type &&
                options.project_type.map((term) => (
                  <option key={term.value} value={term.value}>
                    {term.label}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div className="w-64">
          <label htmlFor="postStatus" className="block pr-4 mb-1">
            Status
          </label>
          <div className="w-full relative col-span-1 col-start-2 select-arrow">
            <select
              id="postStatus"
              name="type"
              className="w-full border p-2 appearance-none select-arrow"
              onChange={(e) =>
                e.target.value === ""
                  ? setValues({ ...values, postStatus: [], page: 1 })
                  : setValues({ ...values, postStatus: [e.target.value], page: 1 })
              }
            >
              <option value="">Alles</option>
              {options.post_status &&
                options.post_status.map((term) => (
                  <option key={term.value} value={term.value}>
                    {term.label}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <div className="min-w-[992px]">
          <div className="iprt-dashboard-projects-list creator relative text-base">
            <div className="list-head-row flex flex-nowrap justify-between items-end">
              <div className="list-data"></div>
              <div className="list-head">Titel</div>
              <div className="list-head">Type</div>
              <div className="list-head">Datum aangepast</div>
              <div className="list-head">Status</div>
              <div className="list-head"></div>
              <div className="list-head"></div>
            </div>
            <div className="relative min-h-[150px]">
              {posts?.map((post, index) => (
                <div className="list-data-row flex flex-nowrap justify-between items-center">
                  <div className="list-data">
                    <div className="w-[68px] aspect-square relative">
                      <div className="absolute bottom-1 -right-1 z-0">
                        {_getTileShape(post.thumbnailShape, post.color)}
                      </div>
                      <img
                        src={post.imageUrl}
                        alt={post.image_alt}
                        className={`list-thumbnail w-full h-full object-cover relative z-10 clip-path-${post.thumbnailShape}`}
                      />
                    </div>
                  </div>
                  <div className="list-data">{post.title}</div>
                  <div className="list-data">{post.type}</div>
                  <div className="list-data">{post.lastUpdateDate}</div>
                  <div className="list-data">{post.postStatus && post.postStatus.label}</div>
                  <div className="list-data">
                    <div className="grid grid-cols-2 gap-2">
                      <div><a href={`/praktijkervaring/edit/${post.nid}`} className=" hover:opacity-60"><img src={_getBaseUrl('src/assets/inspiratiepunten/icon-edit.svg', true)} alt="Icon" /></a></div>
                      <div>
                        <button className="min-h-fit hover:opacity-60"
                          onClick={() => {
                            setDeletePostNid(post.nid);
                            // setDeleteModal(true);
                          }}
                        ><img src={_getBaseUrl('src/assets/inspiratiepunten/icon-delete.svg', true)} alt="Icon" /></button>
                      </div>
                    </div>
                  </div>
                  <div className="list-data">
                    <a href={post.permalink} target="_self" rel="noopener noreferrer" className="block mx-auto hover:opacity-60"><img src={_getBaseUrl('src/assets/inspiratiepunten/icon-view.svg', true)} alt="Icon" /></a>
                  </div>
                </div>
              ))}
              {(!isFirstLoadPosts && posts.length === 0) && (
                <div className="min-h-[150px] h-full flex items-center justify-center">
                  <p className="text-lg">Geen resultaten</p>
                </div>
              )}
              {isLoadingPosts &&
                <div className="absolute top-0 left-0 w-full h-full z-50 bg-white bg-opacity-75 flex items-center justify-center pointer-events-none">
                  <img src={_getBaseUrl('src/assets/loading.gif', true)} alt="Loading" className="scale-50" />
                </div>
              }
            </div>
            {deletePostNid !== null &&
              <Modal
                title="Project verwijderen?"
                confirmButtonLabel="Verwijderen"
                confirmButtonCss="border-red-800 bg-red-800 text-white hover:bg-white hover:text-red-800"
                onCancel={() => {
                  setDeletePostNid(null);
                }}
                onConfirm={() => {
                  deletePost();
                }}
                isProcessing={isDeletingPost}
              >
                <p className="text-center">{getPostTitle(deletePostNid)}</p>
              </Modal>
            }
          </div>
        </div>
      </div>

      {(!isFirstLoadPosts && totalPages > 1) &&
        <div className="flex justify-center my-16">
          <Pagination
            totalPages={totalPages}
            page={values.page}
            setPage={(page) => {
              setValues({ ...values, page: page });
            }}
          />
        </div>
      }

      {
        posts.length > 0 &&
        <div className="flex justify-end items-center gap-4 mt-16">
          <span className="leading-none whitespace-nowrap flex-shrink-0">Overzicht downloaden als</span>
          <button class="flex text-base gap-5 w-min-content py-2.5 px-6 rounded-full relative justify-center border-solid cursor-pointer align-bottom w-full md:w-fit items-center bg-transparent text-cirBlack border-cirBlack border hover:bg-cirBlack hover:text-white transition-colors"
            onClick={() => {
              downloadCSV(values);
            }}
          >CSV</button>
        </div>
      }

      {showPostSavedMessage && (
        <PostSavedMessage
          title={showPostSavedMessage.title}
          destroyMessage={() => {
            setShowPostSavedMessage(null);
          }}
        />
      )}

      {/* <StateView title="values" values={values} floating collapsed />
      <StateView
        title="Post Nid"
        values={deletePostNid}
        floating
        collapsed
        position="top-4 right-4"
      /> */}
    </React.Fragment>
  );
};

export default InspiratiepuntenDashboard;
